<template>
    <div class="blackList" v-if="permisShow('黑名单查看')">
        <div class="sales_header">
            <div class="chouse_wrap" style="display: flex;justify-content: space-between">
                <ul class="conditions_list">
                    <li class="conditions_list_item">
                        <span class="list_item_title">姓名：</span>
                        <div class="Residential">
                            <el-input v-model="searchData.name" placeholder="请输入" @input="currentPage=1,pageNumber=1,getContralist()"></el-input>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <div class="Residential1">
                            <el-input v-model="searchData.keyWord" placeholder="电话、身份证、备注" @input="currentPage=1,pageNumber=1,getContralist()"></el-input>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>录入人：</span>
                        <div class="Residential">
                            <!--              <el-select-->
                            <!--                v-model="searchData.employeeId"-->
                            <!--                placeholder="请选择"-->
                            <!--                @change="currentPage=1,pageNumber=1,getContralist()"-->
                            <!--                clearable-->
                            <!--              >-->
                            <!--                <el-option-->
                            <!--                  v-for="(item,index) in employeesList"-->
                            <!--                  :key="index"-->
                            <!--                  :label="item.name"-->
                            <!--                  :value="item.id"-->
                            <!--                ></el-option>-->
                            <!--              </el-select>-->
                            <el-autocomplete class="select" popper-class="my-autocomplete" v-model="searchData.employeeName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect" clearable>
                                <template slot-scope="{ item }">
                                    <div class="name" @select="handleSelect">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </div>
                    </li>
                    <li class="conditions_list_item">
                        <span>审批状态：</span>
                        <el-select v-model="searchData.status" placeholder="请选择" @change="currentPage=1,pageNumber=1,getContralist()" clearable>
                            <el-option v-for="(item,index) in approvalList" :key="index" :label="item.statusName" :value="item.statusValue"></el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item total_price_input">
                        <span>录入时间：</span>
                        <span class="total_inp input_box">
                            <el-date-picker v-model="searchData.date" unlink-panels value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="currentPage=1,pageNumber=1,getContralist()"></el-date-picker>
                        </span>
                    </li>
                </ul>
                <el-button type="primary" style="width: 100px;height: 30px;line-height: 1px;margin-right: 20px;" @click="addblackList" v-if="permisShow('黑名单新增')">新增</el-button>
            </div>
        </div>
        <div class="sales_list_wrap">
            <el-table ref="multipleTable" :data="contractLsit" border style="width: 100%;" @row-click="rowColorclick" highlight-current-row>
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="phone" label="电话号码"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="idNumber" label="身份证号"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="employeeName" label="录入人"></el-table-column>
                <el-table-column prop="inputDate" label="录入时间"></el-table-column>
                <el-table-column prop="status" label="审批状态"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span style="margin-right:6px;color:#5e75e6;cursor:pointer" :class="{rowColor:scope.row.id===isRowColor}" @click="toApproveManage(scope.row.applyId)" v-if="btnSave&&scope.row.status=='审批中'||btnSave&&scope.row.status=='审批同意'">查看审批详情</span>
                        <span style="margin-right:6px;color:#5e75e6;cursor:pointer" @click="editblackList(scope.row)" :class="{rowColor:scope.row.id===isRowColor}" v-if="permisShow('黑名单编辑')&&scope.row.status=='待提交'&&btnSave||permisShow('黑名单编辑')&&scope.row.status=='审批拒绝'&&btnSave||permisShow('黑名单编辑')&&!btnSave">编辑</span>
                        <span style="margin-right:6px;color:red;cursor:pointer" :class="{rowColor:scope.row.id===isRowColor}" @click="deleteblackList(scope.row)" v-if="permisShow('黑名单删除')&&scope.row.status=='待提交'&&btnSave||permisShow('黑名单编辑')&&scope.row.status=='审批拒绝'&&btnSave||permisShow('黑名单删除')&&!btnSave">删除</span>
                        <span v-if="scope.row.status=='审批同意'&&btnSave||scope.row.status=='无需审批'&&btnSave" style="color:#5e75e6;cursor:pointer" @click="cancelApproval(scope.row.id)">反审</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer_page">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
        </div>
        <el-dialog :visible.sync="activeShow" v-if="activeShow" width="700px" title="黑名单" :close-on-click-modal="false">
            <div class="dialog_status">
                <div style="color:#FF0000;" v-if="blackText=='edit'&&status=='审批拒绝'">{{applyRemark}}</div>
                <div style="color:#5E75E6;cursor:pointer;" v-if="blackText=='edit'&&status=='审批拒绝'" @click="toApproveManage(applyId)">查看审批详情>></div>
            </div>
            <div class="dialog_content">
                <ul>
                    <li class="item">
                        <div class="item_text">
                            <span>姓名：</span>
                            <el-input v-model="dataList.name"></el-input>
                        </div>
                        <div class="item_text">
                            <span>
                                <span style="color:red">*</span>电话号码：
                            </span>
                            <el-input v-model="dataList.phone"></el-input>
                        </div>
                    </li>
                    <li class="item">
                        <div class="item_text">
                            <span>身份证：</span>
                            <el-input v-model="dataList.idNumber"></el-input>
                        </div>
                        <!-- <div class="item_text" style="color:orange">（电话号码和身份证必须填写一项）</div> -->
                    </li>
                    <li class="item">
                        <span style="width:86px;text-align:right">
                            <span style="color:red">*</span>备注：
                        </span>
                        <el-input type="textarea" v-model="dataList.remark" :rows="4"></el-input>
                    </li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="activeShow = false">取 消</el-button>
                <el-button type="primary" @click="blackStatus('add')">保 存</el-button>
                <el-button type="primary" @click="blackStatus('save')" v-if="blackText=='add'&&btnSave||blackText=='edit'&&btnSave&&status=='待提交'||blackText=='edit'&&btnSave&&status=='审批拒绝'">保存并提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import { queryBlack, addBlack, updateBlack, deleteBlack, employeeQuery, checkStatusGet } from "@/api/manageCenter";
import { queryApprovalWhetherOpen, updateBlackApprovalStatus } from "@/api/houseManage";
export default {
    // name: "黑名单",
    name: "/blackList",
    data() {
        let houseTypes = this.$store.state.houseType;
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            applyRemark: "",
            applyId: "",
            status: "",
            btnSave: false,
            permisList,
            isRowColor: "",
            blackText: "add",
            id: null,
            textarea: "", //作废理由
            title: "", //作废
            ResidentialName: "", //合同编号
            pickerOptions: {
                shortcuts: [
                    {
                        text: "当天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            approvalList: [],//审批状态列表
            contractLsit: [], //黑名单列表
            activeAddshow: false,
            officialList: [],
            activeShow: false, //显示退佣
            houseTypes,
            houseTypeJudge: true, //判断是否显示单价和总价
            searchHouseType: "", //查询状态房源类型
            houseType: "", //房源类型
            houseId: "", //房源编号
            pageNumber: 1,
            pageSize: 20,
            houseTypeId: "", //户型编号
            searchData: {
                name: "", //姓名
                keyWord: "", //关键字
                employeeName: "",
                employeeId: "", //录入人
                status: "",//审批状态
                date: "" //时间
            }, //搜索列表
            dataList: {
                name: "",
                phone: "",
                idNumber: "",
                remark: "",
                status: ""
            },
            permissionLevel: "", //权限级别
            storeList: [], //门店列表
            addType: "新增出售",
            currentPage: 1,
            numberData: [], //合同编号列表
            nameData: [], //业主姓名列表
            doorModelData: [], //户型列表
            payTypeData: [], //付款列表
            selection: [], //标识
            houseData: [], //房源列表
            decorateData: [], //装修列表
            roomIds: [],
            property: "",
            sourceList: [], //来源列表
            propertyList: [], //物业列表
            houseTypeList: [], //房源类型列表
            employeesList: [], //员工列表
            regionData: [], //区域列表
            FilterList: [],
            selectHouseData: [], //选中的房源列表
            collectHouseData: [], //收藏的房源列表
            isTrue: false,
            isIndex: -1,
            total: 0,
            checkList: [],
            dialogVisible: false,
            list: {}
        };
    },
    mounted() {
        this.getContralist();//查询黑名单列表
        this.getApproval();//查询是否开启待审批
        this.getcheckStatusGet();//查询审批状态
    },
    activated() {
        this.getContralist();//查询黑名单列表
        this.getApproval();//查询是否开启待审批
        this.getcheckStatusGet();//查询审批状态
    },
    methods: {
        //反审
        cancelApproval(id) {
            let params = {
                id: id,
                status: "WAITING_FOR_SUBMIT",
            }
            this.$post(updateBlackApprovalStatus, params).then(res => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.getContralist();
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        // //提交审批
        // submitApproval(id) {
        //     let params = {
        //         id: id,
        //         status: "WAITING_FOR_APPROVAL",
        //     }
        //     this.$post(updateBlackApprovalStatus, params).then(res => {
        //         if (res.success) {
        //             this.$message({
        //                 type: "success",
        //                 message: res.msg
        //             });
        //             this.getContralist();
        //         } else {
        //             this.$message({
        //                 type: "error",
        //                 message: res.msg
        //             });
        //         }
        //     })
        // },
        //查询是否开启待审批
        getApproval() {
            let params = {
                approvalType: "whether_black"
            }
            this.$post(queryApprovalWhetherOpen, params).then(res => {
                if (res.success) {
                    if (res.data) {
                        this.btnSave = true;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },
        // 查询员工列表
        // getEmployeesData() {
        //   var params = {
        //     "page.pageNumber": 0,
        //     "page.pageSize": 100000
        //   };
        //   this.$post(employeeQuery, params).then(res => {
        //     if (res.success) {
        //       this.employeesList = res.data;
        //     } else {
        //       this.$message({
        //         message: res.msg,
        //         type: "error"
        //       });
        //     }
        //   });
        // },
        /* 查询审批状态 */
        getcheckStatusGet() {
            this.$post(checkStatusGet).then(res => {
                if (res.success) {
                    this.approvalList = res.data;
                }
            });
        },
        querySearchAsync(queryString, cb) {
            let params = {
                name: queryString,
                status:'ENABLE',
            };

            this.$post(employeeQuery, params).then(res => {
                if (res.success) {
                    this.employeesList = res.data;
                    let restaurants = this.employeesList;
                    cb(restaurants);
                    if (!this.searchData.employeeName) {
                        this.searchData.employeeId = '';
                        this.currentPage = 1;
                        this.pageNumber = 1;
                        this.getContralist()
                    }

                } else {
                }
            });
        },
        handleSelect(item) {
            this.searchData.employeeId = item.id;
            this.searchData.employeeName = item.name;
            this.currentPage = 1;
            this.pageNumber = 1;
            this.getContralist()
            //cosole.log(this.contractMsg.signer)
        },
        //跳转审批详情
        toApproveManage(id) {
            sessionStorage.setItem('customerApplyId', id);
            this.$router.push({ path: "/approveManage" });
            this.activeShow = false;
        },
        //黑名单操作
        blackStatus(btnType) {
            if (!this.dataList.phone) {
                this.$message({
                    message: "电话号码不能为空",
                    type: "error"
                });
                return;
            }
            if (!this.dataList.remark) {
                this.$message({
                    message: "备注不能为空",
                    type: "error"
                });
                return;
            }
            if (this.blackText == "add") {
                let params = Object.assign({}, this.dataList);
                if (btnType == 'add') {
                    params.status = "WAITING_FOR_APPROVAL";
                } else if (btnType == 'save') {
                    params.status = "TO_BE_AUDITED";
                }
                this.$post(addBlack, params).then(res => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: "success"
                        });
                        this.activeShow = false;
                        this.getContralist();
                        this.isRowColor = "";
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            } else if (this.blackText == "edit") {
                let params = Object.assign({}, this.dataList);
                if (btnType == 'add') {
                    params.status = "WAITING_FOR_APPROVAL";
                } else if (btnType == 'save') {
                    params.status = "TO_BE_AUDITED";
                }
                this.$post(updateBlack, params).then(res => {
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: "success"
                        });
                        this.activeShow = false;
                        this.getContralist();
                        this.isRowColor = "";
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //新增黑名单
        addblackList() {
            this.dataList.name = "";
            this.dataList.phone = "";
            this.dataList.idNumber = "";
            this.dataList.remark = "";
            this.activeShow = true;
            this.blackText = "add";
            this.applyRemark = "";
            this.status = "";
            this.applyId = "";
        },
        //编辑黑名单
        editblackList(row) {
            this.dataList.name = row.name;
            this.dataList.phone = row.phone;
            this.dataList.idNumber = row.idNumber;
            this.dataList.remark = row.remark;
            this.dataList.id = row.id;
            this.activeShow = true;
            this.blackText = "edit";
            this.applyRemark = row.applyRemark;
            this.status = row.status;
            this.applyId = row.applyId;
        },
        //删除黑名单
        deleteblackList(row) {
            let params = {
                id: row.id
            };
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            })
                .then(() => {
                    this.$post(deleteBlack, params).then(res => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: "success"
                            });
                            this.currentPage = 1;
                            this.pageNumber = 1;
                            this.getContralist();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        //查询黑名单列表
        getContralist() {
            this.isRowColor = "";
            let params = {
                name: this.searchData.name,
                keyWord: this.searchData.keyWord,
                employeeId: this.searchData.employeeId,
                date: this.searchData.date,
                status: this.searchData.status,
                "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
                "page.pageSize": this.pageSize
            };
            this.$post(queryBlack, params).then(res => {
                if (res.success) {
                    this.contractLsit = res.data;
                    this.total = res.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.getContralist(); //每页显示条数
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.getContralist(); //当前页
        }
    },

};
</script>
<style type="text/css" lang="less">
.sales_list_wrap .el-table--border th.is-leaf {
    background: #f2f4ff;
}
.collect {
    width: 100%;
    height: 100%;
    cursor: pointer;
    i {
        color: #707070;
        &.active {
            color: red;
        }
    }
}
.el-checkbox {
    margin-top: 0;
}
.first_el_dropdown_menu {
    .icon-xiajiantou {
        margin-right: 5px;
    }

    .el-dropdown-menu {
        width: 240px;
        height: 280px;
    }

    #add_title {
        font-size: 14px;
        line-height: 14px;
        color: #999999;
        padding-left: 20px;
        margin-top: 5px;
    }

    .el-select-dropdown__list {
        margin-top: 15px;
    }

    .el-select-dropdown__empty {
        margin-top: 15px;
    }
    .el-popper .popper__arrow,
    .el-popper .popper__arrow::after {
        border: none;
    }

    .el-popper[x-placement^="bottom"] {
        margin-top: 0;
    }

    .el-dropdown-menu__item {
        float: left;
        width: 33.33%;
        display: flex;
        flex-direction: column;
        line-height: 15px;
        padding: 0;
        align-items: center;
        margin-top: 28px;
        color: #5e75e6;
        font-size: 14px;
        padding-top: 10px;
    }

    .add_font {
        font-size: 30px;
    }

    .add_sales {
        margin-top: 8px;
    }
}

.blackList {
    height: 100%;
    position: relative;
    .dialog_status {
        margin-left: 40px;
        margin-bottom: 20px;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        div {
            margin-right: 30px;
        }
    }
    .dialog_content {
        .item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            &_text {
                display: flex;
                align-items: center;
                .el-input__inner {
                    height: 30px;
                }
                .el-input__icon {
                    line-height: 30px;
                }
                span {
                    text-align: right;
                    width: 104px;
                }
            }
        }
    }

    .text {
        margin-bottom: 10px;
        vertical-align: middle;
    }
    .must {
        color: #f64e4e;
    }
    .el-table th.is-leaf {
        padding: 5px 0;
    }
    .set-brokerage-head {
        .el-button--primary {
            background: #5e75e6;
            width: 100px;
            height: 30px;
            font-size: 14px;
            line-height: 5px;
        }
    }
    .el-button {
        background: #999999;
        color: #ffffff;
    }
    .el-button--primary {
        background: #5e75e6;
    }
    .el-dialog__header {
        margin: 20px;
        .el-dialog__title {
            color: #5e75e6;
            font-size: 20px;
        }
    }

    .el-dialog__body {
        margin: 0 40px 30px 40px;
    }
    .sales_header {
        background: white;
        position: relative;

        .chouse_wrap {
            display: flex;
            height: 60px;
            align-items: center;
            .conditions_list {
                display: flex;
                > p {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #bbb;

                    .icon-xiajiantou {
                        &.active {
                            transform: rotate(180deg);
                        }
                    }

                    > span {
                        padding-left: 5px;
                    }
                }

                .conditions_list_item {
                    display: flex;
                    align-items: center;
                    margin-left: 20px;
                    > span {
                        font-size: 12px;
                        color: #666;
                        min-width: 24px;
                    }
                    .Residential {
                        .el-input__inner {
                            width: 140px;
                            height: 30px;
                            border: 1px solid #dbdbdb;
                        }
                    }
                    .Residential1 {
                        .el-input__inner {
                            width: 200px;
                            height: 30px;
                            border: 1px solid #dbdbdb;
                        }
                    }
                    .el-select {
                        .el-input {
                            .el-input__inner {
                                width: 120px;
                                height: 30px;
                                border: 1px solid #dbdbdb;
                            }

                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                    }

                    .el-input-group {
                        .el-input-group__append {
                            padding: 0 19px;
                            background: #5e75e6;

                            .icon-icon_sousuo {
                                color: white;
                            }
                        }

                        .el-input__inner {
                            height: 30px;
                            background: #f5f5f5;
                            padding-left: 0;
                            border: none;
                            width: 120px;
                        }
                    }

                    &.total_price_input {
                        display: flex;
                        height: 30px;

                        .total_inp {
                            display: flex;
                            align-items: center;
                            border: none;

                            .el-range-editor.el-input__inner {
                                height: 30px;
                                line-height: 30px;
                                .el-range-separator {
                                    height: 30px;
                                    line-height: 30px;
                                }
                                .el-input__icon {
                                    height: 30px;
                                    line-height: 30px;
                                }
                            }
                        }
                    }
                }
            }
            .button_list {
                button {
                    padding: 6px 20px;
                    background: #5e75e6;
                    color: #ffffff;
                    border: none;
                    margin-left: 20px;
                }
                button:nth-child(2) {
                    background: #f5f5f5;
                    color: #5e75e6;
                }
            }
            .chouse_box {
                display: flex;

                .chouse_item {
                    cursor: pointer;
                    margin-left: 20px;
                    text-align: center;

                    > i {
                        font-size: 20px;
                        color: #999999;
                    }

                    > p {
                        font-size: 14px;
                        margin-top: 5px;
                        color: #999999;
                    }

                    &.active {
                        > i {
                            color: #5e75e6;
                        }

                        > p {
                            color: #5e75e6;
                        }
                    }
                }
            }

            .sales_line {
                width: 1px;
                height: 40px;
                background: #cccccc;
                margin-left: 10px;
            }

            .chouse_btns {
                margin-left: 20px;
                font-size: 14px;
                color: #999999;

                .sales_empty {
                    margin-bottom: 10px;
                }

                > p {
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    > span {
                        padding-left: 5px;
                    }
                }
            }
        }
        .sales_contrast {
            min-width: 56px;
            padding: 5px 20px;
            background: #f5f5f5;
            margin-right: 34px;
            font-size: 14px;
            color: #ffffff;
            background: #5e75e6;
            border-radius: 3px;
            cursor: pointer;
            display: flex;
            align-items: center;

            .icon-icon_duibi {
                font-size: 24px;
            }
        }
    }
    .footer_page {
        position: absolute;
        right: 30px;
        padding: 20px;
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #5e75e6;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
            border: 1px solid #ccc;
            background: white;
        }
    }
}
</style>
